'use strict';
const { queryFirst, queryAll } = require('./domUtil');

document.addEventListener('DOMContentLoaded', () => {
    const blogPagingBlock = queryFirst('.js-blog-pagination');
    if (!blogPagingBlock) return;

    const paginationButtons = queryAll('.js-pagination-blog-page', blogPagingBlock);

    paginationButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const { target } = e;
            let url = target.getAttribute('data-url');
            let pageNumber = target.getAttribute('data-page-number');
            if (url && pageNumber) {
                window.location.href = url;
            }
        });
    });
});
